// "Recent implementation requests" panel on the admin dashboard.
// Verbatim from AdminDashboard.jsx (W2d).
export default function RecentImplList({ recentImplementationRequests }) {
  return (
    <div className="sf-card" data-testid="recent-impl-card">
      <div className="sf-eyebrow" style={{ marginBottom: 10 }}>Recent implementation requests</div>
      {recentImplementationRequests.length === 0 && <div className="sf-muted-text" style={{ fontSize: 13 }}>None yet.</div>}
      {recentImplementationRequests.map((ir) => (
        <div
          key={ir.request_id}
          className="sf-mono"
          style={{ fontSize: 12, padding: "8px 0", borderBottom: "1px dashed #22262B" }}
          data-testid={`recent-impl-${ir.request_id}`}
        >
          <div>{ir.name} · {ir.business}</div>
          <div className="sf-muted-text" style={{ fontSize: 11 }}>{ir.preferred_tier} · {ir.status}</div>
        </div>
      ))}
    </div>
  );
}
